import { useEffect } from 'react';

import type { UseSalesFunnelsEffectsProps } from '@pages/SalesFunnels/SalesFunnelsRegistry/types';

export const useSalesFunnelsEffects = ({
  getSalesFunnelsListHandler,
}: UseSalesFunnelsEffectsProps) => {
  useEffect(() => {
    getSalesFunnelsListHandler();
  }, [getSalesFunnelsListHandler]);
};
